var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataBrokerDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4ca0ff",
    fillRule: "evenodd",
    d: "M12.419 9.06V5.711H.205V3.545h12.214V0l5.589 4.53z",
    transform: "translate(14.992 15)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006dc9",
    fillRule: "evenodd",
    d: "M17.8 14.4H5.589v3.545L0 13.413l5.589-4.531v3.348H17.8z",
    transform: "translate(15 15.058)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBrokerDefault);
export default __webpack_public_path__ + "static/media/data-broker-default.ee078463e5b61562df9fa81695d3cb4f.svg";
export { ForwardRef as ReactComponent };